import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { BottomSheetContentLayout, Box, Button, Column } from 'seagull';
import { BuildLineColumns } from './columns';
export function ChargeEditSheet(param) {
    let { item, columnParams, mode, issueDate, header, submitLabel, submitTestId, onApply, onClose } = param;
    var _useWatch;
    const draftForm = useForm({
        mode: 'all',
        defaultValues: {
            mode,
            issueDate,
            items: [
                item
            ]
        }
    });
    const draftItem = (_useWatch = useWatch({
        control: draftForm.control,
        name: 'items.0'
    })) !== null && _useWatch !== void 0 ? _useWatch : item;
    const editableColumns = useMemo(()=>BuildLineColumns(_object_spread_props(_object_spread({}, columnParams), {
            control: draftForm.control,
            trigger: draftForm.trigger
        })).filter((column)=>!column.isPrimary && column.renderEdit != null), [
        columnParams,
        draftForm.control,
        draftForm.trigger
    ]);
    const apply = async ()=>{
        const isValid = await draftForm.trigger();
        if (!isValid) return;
        onApply(draftForm.getValues('items.0'));
        onClose();
    };
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentGutter: "m",
        header: _object_spread({
            gutter: 'm'
        }, header),
        footer: {
            paddingBottom: 16,
            content: /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'bill_item_edit_submit'
                },
                fullWidth: true,
                testId: submitTestId,
                onClick: apply,
                children: submitLabel
            })
        },
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 16,
            children: editableColumns.map((column)=>{
                var _column_renderEdit;
                return /*#__PURE__*/ _jsx(Box, {
                    children: (_column_renderEdit = column.renderEdit) === null || _column_renderEdit === void 0 ? void 0 : _column_renderEdit.call(column, draftItem, 0)
                }, column.key);
            })
        })
    });
}
